import { v4 } from 'uuid'

export const createTraceId = () => v4().replace(/-/gi, '')

export const createTimestamp = () => Date.now() * 1_000_000
